import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'

import SlideOver from '@/components/core/SlideOver.vue'
import TripSidebarContent from '@/components/trip/sidebar/TripSidebarContent.vue'
import { eventModule } from '@/store'


export default /*#__PURE__*/_defineComponent({
  __name: 'TripSidebarMobile',
  setup(__props) {

const showSidebar = computed({
  get: () => eventModule.navigationDrawer,
  set: (value) => eventModule.toggleNavigationDrawer(value),
})

const expandSidebar = ref(true)

return { __sfc: true,showSidebar, expandSidebar, SlideOver, TripSidebarContent }
}

})